import React, { useEffect, useState } from 'react';
import OffersCarousel from '../components/OffersCarousel';
import { getMenus } from '../services/apiservice';
import { Button, Empty, Skeleton } from 'antd';
import { FLAG_LIST, HOTEL_IMAGE_URL, MENU_IMAGE_BASEURL } from '../constants';
import { useNavigate } from 'react-router-dom';
import LanguagePopup from '../components/LanguagePopup';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeftOutlined } from '@ant-design/icons';

import { useHotel } from '../context/HotelContext';
import { getBanner } from '../helpers/_commonHelper';

const Home = () => {
    const [menuList, setMenuList] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { langList, lang } = useLanguage();
    console.log({ lang });

    const { t } = useLanguage();
    const { hotelDetails = {} } = useHotel();

    const offersList = getBanner(String(hotelDetails.id));

    useEffect(() => {
        window.scrollTo(0, 0);
        hasLanguagePreferences();
    }, [langList]);

    useEffect(() => {
        fetchMenus();
    }, []);
    const fetchMenus = async () => {
        try {
            setLoading(true);
            const response = await getMenus();
            console.log(response);
            if (response.status === 200) {
                let menus = response.data.data || [];
                menus = menus.filter((menu) => Boolean(menu.enabled));
                setMenuList(menus);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const menuClickHandler = (menu) => {
        navigate(`/categories?menuid=${menu.id}`);
    };
    const hasLanguagePreferences = () => {
        try {
            const response = localStorage.getItem('lang');
            if (langList.length === 0 || response) {
                setIsModalOpen(false);
            } else {
                setIsModalOpen(true);
            }
        } catch (error) {}
    };
    const LandingNavigation = () => (
        <div className='header-new bg-gray-900 flex justify-between items-center landing-navigation  px-4 z-99 min-h-16 max-h-16 sticky top-0 z-50'>
            <Button
                // shape='circle'
                size='large'
                icon={<ArrowLeftOutlined />}
                className='shadow-sm'
                onClick={() => navigate(-1)}
            >
                {t['back_btn_text']}
            </Button>

            <div className='logo-container w-28'>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTEL_IMAGE_URL}${hotelDetails.logo}`}
                        alt={`${hotelDetails?.name} logo`}
                        className='max-h-12 w-full object-contain'
                    />
                )}
            </div>
            {langList.length > 0 ? (
                <div
                    className='language-selector'
                    onClick={() => setIsModalOpen(true)}
                >
                    {/* <GlobalOutlined
                        style={{ color: '#fff', fontSize: '1.5rem' }}
                    /> */}
                    <div className='flex font-medium text-black text-4xl justify-center items-center'>
                        {FLAG_LIST[lang.toUpperCase()]}
                    </div>
                </div>
            ) : (
                <div className='w-6 h-6'></div>
            )}
        </div>
    );
    return (
        <>
            <LandingNavigation />
            <div className=' flex flex-col w-full min-h-screen relative bg-gray-900 gap-4 px-4 pt-4'>
                <div className='carousel-home '>
                    <OffersCarousel imgList={offersList} />
                </div>

                <div className='flex flex-row flex-wrap gap-4 pb-16 justify-between'>
                    {loading ? (
                        <LoadingSkelton />
                    ) : menuList.length === 0 ? (
                        <Empty />
                    ) : (
                        <>
                            {menuList.map((menu) => {
                                return (
                                    <div
                                        key={menu.id}
                                        className='category-card  relative  min-h-80 w-1/2 bg-no-repeat bg-cover bg-center cursor-pointer shadow-sm '
                                        onClick={() => menuClickHandler(menu)}
                                        style={{
                                            backgroundImage: menu?.image
                                                ? `url(${MENU_IMAGE_BASEURL}` +
                                                  encodeURI(menu?.image)
                                                      .replace('(', '%28')
                                                      .replace(')', '%29') +
                                                  ')'
                                                : '',
                                        }}
                                    >
                                        <div className='categoty-title flex text-xl bg-opacity-90 p-4 w-full absolute bottom-0 text-white text-left font-normal'>
                                            {menu.name}
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </div>
                <div className='flex flex-col text-center justify-center items-center py-4 fixed bottom-0 left-0 w-full bg-gray-900'>
                    {menuList.length > 0 ? (
                        <div
                            className='flex flex-col font-normal text-xs text-gray-300'
                            dangerouslySetInnerHTML={{
                                __html: menuList[0].description || '',
                            }}
                        ></div>
                    ) : (
                        <>
                            <div
                                className='flex flex-col font-normal text-xs text-gray-300'
                                dangerouslySetInnerHTML={{
                                    __html: t['restaurant_disclaimer_msg_one'],
                                }}
                            ></div>
                        </>
                    )}
                </div>
                {isModalOpen && (
                    <LanguagePopup
                        isModalOpen={isModalOpen}
                        setIsModalOpen={setIsModalOpen}
                    />
                )}
            </div>
        </>
    );
};

export default Home;

const LoadingSkelton = () => {
    return (
        <>
            <Skeleton
                active
                style={{ color: '#fff', fill: '#fff', stroke: '#fff' }}
            ></Skeleton>
            <Skeleton
                active
                style={{ color: '#fff', fill: '#fff', stroke: '#fff' }}
            ></Skeleton>
            <Skeleton
                active
                style={{ color: '#fff', fill: '#fff', stroke: '#fff' }}
            ></Skeleton>
        </>
    );
};
